import { getBuilders } from '@/helpers/panelcard/builders';


const builders = getBuilders();

export async function buildCards(projectTasks, matchOnSchemaName = false) {

  const cards = [];

  projectTasks.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));

  for (const projectTask of projectTasks) {

    var schemaIsQtacEntity = !!projectTask.qtacEntityName;

    let builderEntry;
    
    if (schemaIsQtacEntity) {
      builderEntry = builders.find(b => b.schemaName === projectTask.qtacEntityName);
    } else if (matchOnSchemaName) {
      builderEntry = builders.find(b => b.schemaName === projectTask.schemaName);
    } else {
      builderEntry = builders.find(b => b.type === projectTask.taskType);
    }

    if (builderEntry) {
      const card = await builderEntry.execute(projectTask.taskId);
      cards.push(card);
    }

  }

  return cards;
}





